module.exports = __webpack_public_path__ + "static/media/bill.ad44e823.svg";